export class ConstantsWebexApi {
    // relative url > you have to add protocoll and domain (https://<domain>)
    // this part will be replaced by proxy-component
    public static readonly ProxyUrl: string = "/psa/webexapi/v1.0";

    public static readonly PartApiVersionPath: string = "/v1";

    public static readonly Part1People: string = "/people";

}
